const makeTechInfoObj = (techInfoText) => {
  if (!techInfoText || typeof techInfoText !== 'string') {
    return [];
  }
  let techInfo = techInfoText.trim();
  if (techInfo.includes('\n')) {
    techInfo = techInfo.split('\n');
  } else {
    techInfo = techInfo.split('; ');
  }
  techInfo = techInfo.sort();
  const techInfoObj = [];
  techInfo.forEach(item => {
    const itemEq = item.replace(" CLASS ", " CLASS - ").split(' - ');
    techInfoObj.push({ name: itemEq[0], value: (itemEq[1] && itemEq[1].trim()) || 'unspecified' });
  });
  return techInfoObj;
}

export default makeTechInfoObj;


// WEBPACK FOOTER //
// ./src/components/grids/TechInfoGrid/makeTechInfoObj.jsx